import { useId, type JSX } from 'react';
import { nights } from '../calendar/monthGrid';
import { useT } from '../i18n/useT';
import type { BookingDraft } from './bookingForm';
import { Field } from './FieldError';

interface StepProps {
  draft: BookingDraft;
  errors: Record<string, string>;
  onChange: (patch: Partial<BookingDraft>) => void;
}

export const WhenStep = ({ draft, errors, onChange }: StepProps): JSX.Element => {
  const t = useT();
  const kindId = useId();
  const count = draft.from !== '' && draft.to > draft.from ? nights(draft.from, draft.to) : 0;
  return (
    <div className="ow-form">
      <h3 className="ow-step-heading" tabIndex={-1} data-step-heading>
        {t('When')}
      </h3>
      <fieldset className="ow-choice" aria-labelledby={kindId}>
        <legend id={kindId} className="ow-label">
          {t('What')}
        </legend>
        <label className="ow-choice-option">
          <input
            type="radio"
            name="kind"
            checked={draft.kind === 'stay'}
            onChange={() => {
              onChange({ kind: 'stay' });
            }}
          />
          {t('Own stay')}
        </label>
        <label className="ow-choice-option">
          <input
            type="radio"
            name="kind"
            checked={draft.kind === 'block'}
            onChange={() => {
              onChange({ kind: 'block' });
            }}
          />
          {t('Maintenance block')}
        </label>
      </fieldset>
      <Field label={t('From')} error={errors['from']}>
        {(a11y) => (
          <input
            {...a11y}
            className="ow-field"
            type="date"
            value={draft.from}
            onChange={(e) => {
              onChange({ from: e.target.value });
            }}
          />
        )}
      </Field>
      <Field label={t('To')} error={errors['to']}>
        {(a11y) => (
          <input
            {...a11y}
            className="ow-field"
            type="date"
            value={draft.to}
            onChange={(e) => {
              onChange({ to: e.target.value });
            }}
          />
        )}
      </Field>
      {count > 0 && (
        <p className="ow-muted">{count === 1 ? t('1 night') : t('{0} nights', { 0: count })}</p>
      )}
      <label className="ow-label">
        {t('Comment (optional)')}
        <textarea
          className="ow-field ow-textarea"
          rows={3}
          value={draft.comment}
          onChange={(e) => {
            onChange({ comment: e.target.value });
          }}
        />
      </label>
    </div>
  );
};
